import React from "react";

import {
  Box,
  Button,
  Container,
  Grid,
  IconButton as MuiIconButton,
  makeStyles,
} from "@material-ui/core";
import { ContactSupport } from "@material-ui/icons";

import { SupportDialog } from "@ip-partials";
import { capitalizeText, publicPath } from "@ip-utils";

const useStyles = makeStyles((theme) => ({
  button: {
    color: theme.palette.common.white,
    opacity: 0.6,
    "&:hover": {
      opacity: 1,
      cursor: "pointer",
    },
  },
}));

export default function Footer() {
  const classes = useStyles();

  const socials = ["facebook", "slack", "wiki"]
    .map((item) => ({
      icon: publicPath(`/media/${item}.svg`),
      title: capitalizeText(item),
      url: process.env[`REACT_APP_${item.toUpperCase()}_URL`],
    }))
    .filter((item) => !!item.url);

  const supportButton = (
    <MuiIconButton
      className={classes.button}
      size="small"
      title="Contact Support"
    >
      <ContactSupport fontSize="small" />
    </MuiIconButton>
  );

  return (
    <Box
      bgcolor="iglu.denimBlue"
      paddingBottom={1}
      paddingTop={1}
      displayPrint="none"
    >
      <Container>
        <Box display="flex" justifyContent="space-between">
          <Grid container spacing={1}>
            {socials.map((link, key) => (
              <Grid item key={key}>
                <Button
                  className={classes.button}
                  component="a"
                  href={link.url}
                  rel="noopener noreferrer"
                  target="_blank"
                  title={link.title}
                >
                  <img
                    alt={link.title}
                    src={link.icon}
                    width={16}
                    height={16}
                  />
                </Button>
              </Grid>
            ))}
          </Grid>
          <SupportDialog button={supportButton} />
        </Box>
      </Container>
    </Box>
  );
}
